import { render, staticRenderFns } from "./IAChat.vue?vue&type=template&id=250fff70&"
import script from "./IAChat.vue?vue&type=script&lang=js&"
export * from "./IAChat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports